import React from "react";

export default function FootballIcon({ className = "w-16 h-16" }) {
    return (
        <svg
            className={className}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <ellipse
                cx="32"
                cy="32"
                rx="24"
                ry="28"
                fill="#7FFF00"
                stroke="#0A1E3E"
                strokeWidth="2"
            />
            <path d="M20 32H44" stroke="#0A1E3E" strokeWidth="2" />
            <path
                d="M24 24L28 28M28 28L32 32M32 32L36 28M36 28L40 24"
                stroke="#0A1E3E"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M24 40L28 36M28 36L32 32M32 32L36 36M36 36L40 40"
                stroke="#0A1E3E"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M14 26C16 22 20 18 32 18C44 18 48 22 50 26"
                stroke="#0A1E3E"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M14 38C16 42 20 46 32 46C44 46 48 42 50 38"
                stroke="#0A1E3E"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
}
